import { render, staticRenderFns } from "./SymptomInvestigationTable.vue?vue&type=template&id=7e4c4d36&scoped=true"
import script from "./SymptomInvestigationTable.vue?vue&type=script&lang=js"
export * from "./SymptomInvestigationTable.vue?vue&type=script&lang=js"
import style0 from "./SymptomInvestigationTable.vue?vue&type=style&index=0&id=7e4c4d36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4c4d36",
  null
  
)

export default component.exports